import config from 'config';
import axios from 'axios';
import moment from 'moment'

var FormData = require('form-data');

export const insuranceClaimsService = {
  getInsuranceClaims,
  getInsuranceClaimsOfPolicy,
  getInsuranceClaimsTable,
  getClaimLog,
  submitFile,
  deleteFile,
  submitMail,
  getEmployees,
  getEmailsFromClaim,
  shortClaimLogByDate,
  getNLastClaimLog
}

async function callToAPI(url, op, data) {
  let config = {
    method: op,
    url: url,
    headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).access}` },
    'Content-Type': 'application/json',
    data: data
  };
  let response = await axios(config)
    .then((response) => {
      console.log("Respuesta")
      console.log(response)
      return response.data
    })
    .catch((error) => {
      let mensajeError = {}
      mensajeError.error = error
      if (error.response.status === 401) {
        //place your reentry code
        mensajeError.msg = "No está autenticado en el sistema o su usuario ha caducado"
       }
      console.log(mensajeError)
      return mensajeError
      });
  return response
}

async function getInsuranceClaims() {
  let insuranceClaims = await callToAPI(`${config.apiUrl}/cartera/siniestros/`, 'get', {});
  return insuranceClaims
}


async function getEmployees() {
  let employees = await callToAPI(`${config.apiUrl}/siniestros/empleados/`, 'get', {});
  return employees
}

async function getInsuranceClaimsOfPolicy(poliza) {
  let insuranceClaims = await callToAPI(`${config.apiUrl}/cartera/siniestros/${poliza}`, 'get', {});
  return insuranceClaims
}


async function getClaimLog(claim_id) {
  let data = new FormData();
  data.append("claim_id", claim_id);
  let insuranceClaims = await callToAPI(`${config.apiUrl}/cartera/gestiones/`, 'post', data);
  return insuranceClaims
}


async function getNLastClaimLog(numTopClaimLog) {
  let data = new FormData();
  data.append("num_top", numTopClaimLog);
  let insuranceClaims = await callToAPI(`${config.apiUrl}/cartera/ultimas-gestiones/`, 'post', data);
  return insuranceClaims
}


function emailListToClaimLogList(emailList) {
  return emailList.map(function (email, index, array) {
    return {
      erp_id: 'EMAIL',
      fecha_gestion: moment(new Date(email.timestamp)).format('DD/MM/YYYY'),
      usuario: JSON.parse(email.remitente).email,
      descripcion: `Email de ${JSON.parse(email.remitente).email} a ${email.destino}`,
      observaciones: email.mensaje
    };
  });
}


function shortClaimLogByDate(claimLog) {
  return claimLog.sort(function(a, b) {
    console.log(`${a.fecha_gestion} comparado con ${b.fecha_gestion}`)
    var keyA = moment(a.fecha_gestion, 'DD/MM/YYYY')
    var keyB = moment(b.fecha_gestion, 'DD/MM/YYYY');
    // Compare the 2 dates
    if (keyA < keyB) {
      return 1

    }
    if (keyB < keyA) {
      return -1
    };
    if (keyB == keyA) {
      return 0
    };

  });
}

async function getEmailsFromClaim(claim_id) {
  let emailList = await callToAPI(`${config.apiUrl}/siniestros/email-from-claim/${claim_id}/`, 'get', {});
  return emailListToClaimLogList(emailList)
}


function getInsuranceClaimsTable(insuranceClaimsList, filterNonClosed=true) {
  let tableOfInsuranceClaims = []
  insuranceClaimsList.forEach(insuranceClaim => {
    let rowVariant = ''
    if (insuranceClaim.claim_end_date) rowVariant = 'success'
    let element = {
      isActive: true,
      claim_id: insuranceClaim.erp_id,
      claim_company_reference: insuranceClaim.claim_company_reference,
      policy_company_id: insuranceClaim.policy_company_id,
      cli_business_name: insuranceClaim.cli_business_name,
      policy_company_business_name: insuranceClaim.policy_company_business_name,
      line_of_insurance_description: insuranceClaim.line_of_insurance_description,
      claim_start_date: insuranceClaim.claim_start_date,
      claim_end_date: insuranceClaim.claim_end_date,
      last_update_date: insuranceClaim.last_update_date,
      last_update_subject: insuranceClaim.last_update_subject,
      description: insuranceClaim.description,
      _rowVariant: rowVariant
    }
    tableOfInsuranceClaims.push(element);
  }
  )

  if (filterNonClosed) {
    return tableOfInsuranceClaims.filter(
      claim => claim._rowVariant != 'success'
    )
  }
  else {
    return tableOfInsuranceClaims
  }


}

async function submitFile(fileData) {
  let fileSent = await callToAPI(`${config.apiUrl}/siniestros/upload-file/`, 'post', fileData);
  return fileSent
}


async function deleteFile(file_uuid) {
  let fileSent = await callToAPI(`${config.apiUrl}/siniestros/delete-file/${file_uuid}/`, 'delete', {});
  return fileSent
}


async function submitMail(mailData) {
  let fileSent = await callToAPI(`${config.apiUrl}/siniestros/email/`, 'post', mailData);
  return fileSent
}

async function newClaimSubmitMail(mailData) {
  let fileSent = await callToAPI(`${config.apiUrl}/siniestros/email/`, 'post', mailData);
  return fileSent
}
